import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ThemeProvider as ThemeProvider2 } from "@mui/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { es } from "date-fns/locale";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PersistGate } from "redux-persist/integration/react";
import { themeMui } from './components/styled/Theme';
import VersionUpdateDialog from "./components/version/versionDialog";
import colors from "./config/colors";
import "./index.css";
import { persistor, store } from "./redux/store/store";
import Routing from "./routes/Routing";
const themeMuiTheme = createTheme(colors);


const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
        <ThemeProvider2 theme={themeMuiTheme}>
          <ThemeProvider theme={themeMui}>
            <BrowserRouter basename={CONFIG.path}>
              <Routing />
            </BrowserRouter>
            <VersionUpdateDialog />
            <ToastContainer
              position="bottom-right"
              hideProgressBar
              theme="colored"
            />
          </ThemeProvider>
        </ThemeProvider2>
        </LocalizationProvider>
      </PersistGate >
    </Provider >
  );
};

export default App;
